import React from 'react';
import { observer } from 'mobx-react';
import { AllResolversProps } from './types';
import { useFlattenFields } from '20.formLib/DeclarationContainer/contexts';
import FilteredListsResolver from '20.formLib/DeclarationContainer/AllResolvers/FilteredListsResolver';
import VisibilitiesResolver from '20.formLib/DeclarationContainer/AllResolvers/VisibilitiesResolver';
import ComputedFieldsResolver from '20.formLib/DeclarationContainer/AllResolvers/ComputedFieldsResolver';
import ErrorsResolver from '20.formLib/DeclarationContainer/AllResolvers/ErrorsResolver';
import ReferencesResolver from '20.formLib/DeclarationContainer/AllResolvers/ReferencesResolver';
import QCScriptsResolver from '20.formLib/DeclarationContainer/AllResolvers/QCScriptsResolver';

const AllResolvers = ({
  children,
  updateFieldVisibility,
  clearFieldVisibilityCache,
  updateDeclaration,
  setCanSubmit,
  updateFieldErrors,
  forceFieldUpdate,
  formType,
}: AllResolversProps) => {
  return (
    <>
      <VisibilitiesResolver
        updateFieldVisibility={updateFieldVisibility}
        clearFieldVisibilityCache={clearFieldVisibilityCache}
      >
        <ComputedFieldsResolver updateDeclaration={updateDeclaration} updateFieldErrors={updateFieldErrors}>
          <ErrorsResolver updateFieldErrors={updateFieldErrors} setCanSubmit={setCanSubmit} formType={formType}>
            <ReferencesResolver updateDeclaration={updateDeclaration} forceFieldUpdate={forceFieldUpdate}>
              <QCScriptsResolver updateDeclaration={updateDeclaration} updateFieldVisibility={updateFieldVisibility}>
                <FilteredListsResolver updateDeclaration={updateDeclaration} forceFieldUpdate={forceFieldUpdate}>
                  {children}
                </FilteredListsResolver>
              </QCScriptsResolver>
            </ReferencesResolver>
          </ErrorsResolver>
        </ComputedFieldsResolver>
      </VisibilitiesResolver>
    </>
  );
};

export default observer(AllResolvers);
